var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaArrowRightDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5101_100386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    fill: "white",
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5101_100386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.59 24.59L21.17 20L16.59 15.41L18 14L24 20L18 26L16.59 24.59Z",
    fill: "#E0E0E0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5101_100386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5101_100386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaArrowRightDisabled);
export default __webpack_public_path__ + "static/media/pa_arrow_right_disabled.44ad0b3ec44123fc4dacab996fc70a51.svg";
export { ForwardRef as ReactComponent };